import { Directive } from '@angular/core';

import { LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';
import { entityMultiSelectText } from 'src/app/common-components/multi-select/entity-multi-select-text-content';
import { ExtensionGroupOption } from '../models/extension-group-option';

@Directive({
    selector: 'lcs-multi-select-trigger[ndtExtensionGroupMultiSelect]',
    standalone: false
})
export class ExtensionGroupMultiSelectTriggerDirective {
   constructor(trigger: LcsMultiSelectTriggerComponent<ExtensionGroupOption>) {
      trigger.getTextContent = entityMultiSelectText(trigger, 'extension group');
   }
}
